import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  paper: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.warning.main
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  button: {
    marginLeft: theme.spacing(2)
  }
});

const UnderwriteWarningBanner = ({ classes, message, actionButtonText, onActionClick, contentButtonText, style, height, width, children, }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  function handleContentClick(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }
  const open = Boolean(anchorEl);
  return (
    <Paper className={classes.paper} style={{ ...style, height, width }}>
      <div className={classes.content}>
        {/* <WarningIcon/> */}
        <Typography variant='subtitle2'>{message}</Typography>
        {actionButtonText && onActionClick &&
          <Button className={classes.button} variant='outlined' size='small' onClick={onActionClick}>{actionButtonText}</Button>
        }
        {contentButtonText &&
          <Button className={classes.button} variant='outlined' size='small' onClick={handleContentClick}>{contentButtonText}</Button>
        }
        <Popover
          //id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {children}
        </Popover>
      </div>
    </Paper>
  )
};

export default withStyles(styles)(UnderwriteWarningBanner);